import { APP_MANAGED_ANCHORS } from 'common/app-managed-routes';

const SECTION_HEADER_ID_MAP: Record<string, string> = {
  'need-help-contact-us': APP_MANAGED_ANCHORS.SUPPORT.NEED_HELP,
  'your-insurance-coverage': APP_MANAGED_ANCHORS.BENEFITS.INSURANCE_COVERAGE,
  'your-additional-benefits': APP_MANAGED_ANCHORS.BENEFITS.ADDITIONAL_BENEFITS,
};

export const getSectionHeaderId = (heading: string) => {
  const normalizedHeading = heading
    .replace(/[^a-zA-Z-_]/g, '-')
    .replace(/-+/g, '-')
    .toLowerCase();
  return SECTION_HEADER_ID_MAP[normalizedHeading] || normalizedHeading;
};
